export function shouldRegisterServiceWorker({
  environment = process.env.NODE_ENV,
  navigatorObject = globalThis.navigator,
  locationObject = globalThis.location,
} = {}) {
  if (environment !== "production" || !navigatorObject?.serviceWorker || !locationObject) {
    return false;
  }

  return locationObject.protocol === "https:"
    || ["localhost", "127.0.0.1", "::1"].includes(locationObject.hostname);
}

export async function registerPrivacySafeServiceWorker(options = {}) {
  if (!shouldRegisterServiceWorker(options)) return null;
  const navigatorObject = options.navigatorObject || globalThis.navigator;

  try {
    return await navigatorObject.serviceWorker.register("/service-worker.js", {
      scope: "/",
      updateViaCache: "none",
    });
  } catch (error) {
    console.error("Life Circle could not enable offline app-shell support.", error);
    return null;
  }
}
